export interface Airport {
  code: string
  name: string
  lat: number
  lon: number
  cityUrlSlug: string
}

export interface Town {
  key: string
  name: string
  lat: number
  lon: number
  cityUrlSlug: string
  airports?: Airport[]
  // Grammatical forms for Polish: "w + locative" (w Gdańsku, w Krakowie)
  locativeForm?: string
}

export interface Region {
  towns: Town[]
}

export interface TownResponse {
  name: string
  lat: number
  lon: number
  cityUrlSlug: string
}

export interface AirportResponse {
  code: string
  name: string
  lat: number
  lon: number
  cityName: string
  displayName: string
  cityUrlSlug: string
}

export interface TownsResponse {
  towns: TownResponse[]
  error?: string
}

export interface AirportsResponse {
  airports: AirportResponse[]
  error?: string
}

export const townAndAirportData: Record<string, Region> = {
  pl: {
    towns: [
      {
        key: 'warsaw',
        name: 'Warszawa',
        lat: 52.2297,
        lon: 21.0122,
        cityUrlSlug: 'warsaw',
        locativeForm: 'Warszawie',
        airports: [
          {
            code: 'WAW',
            name: 'warsaw.chopin.airport',
            lat: 52.1657,
            lon: 20.9671,
            cityUrlSlug: 'warsaw-okecie'
          },
          {
            code: 'WMI',
            name: 'warsaw.modlin.airport',
            lat: 52.4492,
            lon: 20.6512,
            cityUrlSlug: 'warsaw-modlin'
          }
        ]
      },
      {
        key: 'cracow',
        name: 'Kraków',
        lat: 50.0647,
        lon: 19.945,
        cityUrlSlug: 'cracow',
        locativeForm: 'Krakowie',
        airports: [
          {
            code: 'KRK',
            name: 'cracow.johnpaul.airport',
            lat: 50.0777,
            lon: 19.7848,
            cityUrlSlug: 'cracow-balice'
          }
        ]
      },
      {
        key: 'katowice',
        name: 'Katowice',
        lat: 50.2649,
        lon: 19.0238,
        cityUrlSlug: 'katowice',
        locativeForm: 'Katowicach',
        airports: [
          {
            code: 'KTW',
            name: 'katowice.international.airport',
            lat: 50.4743,
            lon: 19.08,
            cityUrlSlug: 'katowice-pyrzowice'
          }
        ]
      },
      {
        key: 'gdansk',
        name: 'Gdańsk',
        lat: 54.352,
        lon: 18.6466,
        cityUrlSlug: 'gdansk',
        locativeForm: 'Gdańsku',
        airports: [
          {
            code: 'GDN',
            name: 'gdansk.walesa.airport',
            lat: 54.3776,
            lon: 18.4662,
            cityUrlSlug: 'gdansk-port-lotniczy'
          }
        ]
      },
      {
        key: 'poznan',
        name: 'Poznań',
        lat: 52.4064,
        lon: 16.9252,
        cityUrlSlug: 'poznan',
        locativeForm: 'Poznaniu',
        airports: [
          {
            code: 'POZ',
            name: 'poznan.international.airport',
            lat: 52.4211,
            lon: 16.8262,
            cityUrlSlug: 'poznan-lawica'
          }
        ]
      },
      {
        key: 'wroclaw',
        name: 'Wrocław',
        lat: 51.1079,
        lon: 17.0385,
        cityUrlSlug: 'wroclaw',
        locativeForm: 'Wrocławiu',
        airports: [
          {
            code: 'WRO',
            name: 'wroclaw.copernicus.airport',
            lat: 51.1027,
            lon: 16.8859,
            cityUrlSlug: 'wroclaw-port-lotniczy'
          }
        ]
      },
      {
        key: 'bydgoszcz',
        name: 'Bydgoszcz',
        lat: 53.1235,
        lon: 18.0084,
        cityUrlSlug: 'bydgoszcz-airport',
        locativeForm: 'Bydgoszczy'
      },
      {
        key: 'swinoujscie',
        name: 'Świnoujście',
        lat: 53.9071,
        lon: 14.2488,
        cityUrlSlug: 'swinoujscie',
        locativeForm: 'Świnoujściu'
      },
      {
        key: 'lodz',
        name: 'Łódź',
        lat: 51.75,
        lon: 19.46667,
        cityUrlSlug: 'lodz',
        locativeForm: 'Łodzi',
        airports: [
          {
            code: 'LCJ',
            name: 'lodz.wladyslaw.reymont.airport',
            lat: 51.7219,
            lon: 19.3981,
            cityUrlSlug: 'lodz-port-lotniczy'
          }
        ]
      }
    ]
  },
  ae: {
    towns: [
      {
        key: 'dubai',
        name: 'Dubai',
        lat: 25.2048,
        lon: 55.2708,
        cityUrlSlug: 'dubai',
        locativeForm: 'Dubaju',
        airports: [
          {
            code: 'DXB',
            name: 'dubai.international.airport',
            lat: 25.2532,
            lon: 55.3657,
            cityUrlSlug: 'dubai'
          }
        ]
      }
    ]
  },
  bh: {
    towns: [
      {
        key: 'bahrain',
        name: 'Bahrain',
        lat: 26.0667,
        lon: 50.5577,
        cityUrlSlug: 'manama',
        locativeForm: 'Bahrajnie',
        airports: [
          {
            code: 'BAH',
            name: 'bahrain.international.airport',
            lat: 26.2708,
            lon: 50.6332,
            cityUrlSlug: 'manama'
          }
        ]
      }
    ]
  }
}
